import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Pagination from 'modules/common/components/Pagination';
import { IconSearch } from 'modules/common/components/Icons';
import * as actions from '../actions';
import * as c from '../constants';

function BillsPaymentTransactionContainer({ getBillsList, billsList, pager, isLoading, formData, setFormData }) {

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    getBillsList();
  }, []);

  const handleChangePage = (page) => {
    getBillsList({ ...formData, page });
  };

  const onSearch = (e) => {
    e.preventDefault();
    getBillsList(formData);
  };

  return (
    <>
      {/* <div className="module-inner-title">Bills Payment Transactions</div> */}
      <form onSubmit={onSearch}>
        <div className="row d-flex pr-3 align-items-center">
          <div className="col-3 pr-0">
            <div className="form-search listing">
              <div className="form-control-icon">
                <button type="submit" className="btn-blank p-0">
                  <IconSearch />
                </button>
              </div>
              <input
                className="search-input"
                type="text"
                placeholder="Search Reference Number"
                aria-label="Search"
                onChange={onChange}
                value={formData.q || ''}
              />
            </div>
          </div>
          <div className="col-3">
            <button type="submit" className="btn btn-link button-upload">
              Filter
            </button>
          </div>
        </div>
      </form>
      <div className="bills-table mt-3">
        {isLoading ? (
          <div
            className="loading d-flex text-center justify-content-center align-items-center"
            style={{ height: '500px' }}
          >
            <div className="spinner text-center ">
              <span className="fas fa-5x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <table className="table table-borderless table-striped">
              <thead className="table-header">
                <tr>
                  <th scope="col">Reference No.</th>
                  <th scope="col">Name</th>
                  <th scope="col">Account No.</th>
                  <th scope="col">Biller</th>
                  <th scope="col">Date</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                {billsList &&
                  billsList.map((res) => (
                    <tr key={_.get(res, 'id')}>
                      <td>{_.get(res, 'attributes.reference')}</td>
                      <td>{_.get(res, 'attributes.name')}</td>
                      <td>{_.get(res, 'attributes.account_number')}</td>
                      <td>{_.get(res, 'attributes.biller_code')}</td>
                      <td>{_.get(res, 'attributes.paid_at')}</td>
                      <td>{_.get(res, 'attributes.status')}</td>
                    </tr>
                  ))}
                {billsList && billsList.length <= 0 && <tr><td colSpan="6" className="text-center">No data found</td></tr>}
              </tbody>
            </table>
            <div className="list-pagination">
              {pager.total_pages > 1 ? (
                <div className="d-flex justify-content-center text-center align-item-center">
                  <Pagination data={pager} onChange={handleChangePage} />
                </div>
              ) : (
                ''
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}

BillsPaymentTransactionContainer.propTypes = {
  getBillsList: PropTypes.instanceOf(Function).isRequired,
  billsList: PropTypes.instanceOf(Array).isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  //   pager: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  billsList: _.get(api, `${c.BILLS_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.BILLS_LIST) > -1,
  pager: _.get(api, `${c.BILLS_LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BillsPaymentTransactionContainer);